import React from 'react';
import PropTypes from 'prop-types';
import { Table } from 'reactstrap';
import { useIntl } from 'react-intl';

import DownloadRequestsHeader from './ListHeader';
import DownloadRequestsListItem from './ListItem';

const DownloadRequestsList = ({
  requests,
  loadDownloadRequests,
  ...props
}) => {
  const intl = useIntl();

  return (
    <>
      {requests.length > 0 ? (
        <div className="table-wrapper">
          <Table className="files-list download-files-list users-list requests-list" responsive>
            <thead>
              <DownloadRequestsHeader
                {...props}
              />
            </thead>
            <tbody>
              {requests.map(request => (
                <DownloadRequestsListItem
                  key={request.uuid}
                  request={request}
                  loadDownloadRequests={loadDownloadRequests}
                />
              ))}
            </tbody>
          </Table>
        </div>
      ) : (
        <div className="nothing-found-wrapper bottom">
          <h3>{intl.formatMessage({ defaultMessage: 'No requests found' })}</h3>
        </div>
      )}
    </>
  );
};

DownloadRequestsList.propTypes = {
  requests: PropTypes.array.isRequired,
  loadDownloadRequests: PropTypes.func.isRequired,
};

export default DownloadRequestsList;
